// A gate sentinel must stay findable (a real, clipped 1px box) — display:none reports a zero rect, which now reads as absent.
export const gateSentinelSx = {
	clip: "rect(0, 0, 0, 0)",
	height: "1px",
	margin: "-1px",
	overflow: "hidden",
	position: "absolute",
	whiteSpace: "nowrap",
	width: "1px"
} as const;

export const isAnchorVisible = (element: HTMLElement): boolean => {
	const box = element.getBoundingClientRect();
	if (box.width === 0 && box.height === 0) return false;
	return window.getComputedStyle(element).visibility !== "hidden";
};

export const findVisibleAnchor = (anchorId: string): HTMLElement | null => {
	const candidates = document.querySelectorAll<HTMLElement>(`[data-tour-id="${anchorId}"]`);
	for (const candidate of candidates) {
		if (isAnchorVisible(candidate)) return candidate;
	}
	return null;
};

export const resolveCurrentAnchor = (anchorId: string, current: HTMLElement | null): HTMLElement | null =>
	current?.isConnected && isAnchorVisible(current) ? current : findVisibleAnchor(anchorId);

export const anchorIsPresent = (anchorId: string): boolean => findVisibleAnchor(anchorId) !== null;

const expandedControlOwnsMountedPopup = (element: HTMLElement): boolean => {
	if (element.getAttribute("aria-expanded") !== "true") return false;
	const controlsId = element.getAttribute("aria-controls");
	return controlsId !== null && document.getElementById(controlsId) !== null;
};

// MUI Autocomplete/Select mark their trigger aria-expanded + aria-controls automatically; a bare Menu needs it wired by hand.
export const anchorOwnsOpenPopper = (anchorEl: HTMLElement): boolean =>
	[anchorEl, ...Array.from(anchorEl.querySelectorAll<HTMLElement>("[aria-expanded]"))].some(
		expandedControlOwnsMountedPopup
	);
